module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG7f6189f56e22d5f5050bff40f96f9408.7f6189f5.png";